// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__26201","signatureButtonsRight":"ModalSign_signatureButtonsRight__1mG_O"};